import type { ReactNode } from "react";

import AdminS from "metabase/css/admin.module.css";

import TableS from "./Table.module.css";

type TableProps = {
  columns: number;
  headers: ReactNode[];
  rows?: ReactNode[][];
  emptyState?: ReactNode;
  loadingState?: ReactNode;
  children?: ReactNode;
};

export const Table = ({
  columns,
  headers,
  rows = [],
  emptyState,
  loadingState,
  children,
}: TableProps) => {
  const hasRows = rows.length > 0;
  const hasChildren = Boolean(children);

  return (
    <div className={TableS.TableWrapper}>
      <table className={`${AdminS.ContentTable} ${TableS.Table}`}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={`header-${index}`}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loadingState ? (
            <tr>
              <td className={TableS.EmptyStateCell} colSpan={columns}>
                {loadingState}
              </td>
            </tr>
          ) : hasChildren ? (
            children
          ) : hasRows
            ? rows.map((row, rowIndex) => (
                <tr key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <td key={`cell-${rowIndex}-${cellIndex}`}>{cell}</td>
                  ))}
                </tr>
              ))
            : emptyState && (
                <tr>
                  <td className={TableS.EmptyStateCell} colSpan={columns}>
                    {emptyState}
                  </td>
                </tr>
              )}
        </tbody>
      </table>
    </div>
  );
};
